import React, { useContext, useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';

import { getBgImage, getLogo } from '../../../api/aws/s3';
import { companiesRef } from '../../../api/firebase/firestore/company';
import { usersRef } from '../../../api/firebase/firestore/user';
import {
  mypageHeader,
  mypageHeaderTitle,
  sideBar
} from '../../../constants/Location';
import { agentIndustry } from '../../../constants/Select';
import { screenType, select } from '../../../constants/enum';
import { AuthContext } from '../../../contexts/auth';
import { throwError } from '../../../modules/error';
import noImage from '../../assets/noImage.svg';
import RegisterInfo from '../../uiParts/RegisterInfo';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  mypageHeader,
  mypageHeaderTitle,
  sideBar
};

export const AgentRegisterInfo: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.agent.mypageCompany');
  });

  const { currentUser } = useContext(AuthContext);

  const [userCompany, setUserCompany] = useState({
    bgImgId: '',
    foundationYear: '',
    industry: 0,
    industryOther: '',
    introduction: '',
    logoId: '',
    name: '',
    pressReleases: [],
    status: 2,
    url: ''
  });

  const init = async (): Promise<void> => {
    try {
      if (currentUser) {
        const userRef = doc(usersRef, currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const ownCampanyRef = doc(
            companiesRef,
            userSnap.data()?.companyId as string
          );
          const companySnap = await getDoc(ownCampanyRef);
          const icon = await getLogo(companySnap);
          const bgImg = await getBgImage(companySnap);

          setUserCompany((prevState) => ({
            ...prevState,
            bgImgId: bgImg,
            foundationYear: companySnap.data()?.foundationYear as string,
            industry: companySnap.data()?.industry as number,
            industryOther: companySnap.data()?.industryOther as string,
            introduction: companySnap.data()?.introduction as string,
            logoId: icon,
            name: companySnap.data()?.name as string,
            pressReleases: companySnap.data()?.pressReleases as [],
            status: companySnap.data()?.status as number,
            url: companySnap.data()?.url as string
          }));
        }
      }
    } catch (e) {
      throwError(e);
    }
  };

  const showIndustry = (i: number): string => {
    const data = agentIndustry().find(
      (element): boolean => element.value === i
    );
    if (i === select.other) {
      return userCompany.industryOther;
    }
    return data?.option ?? '';
  };

  const table = {
    aboveDesc: showIndustry(userCompany.industry),
    aboveType: t('common.industryType'),
    middleDesc: `${userCompany.foundationYear}年`,
    middleType: t('common.yearEstablished')
  };

  useEffect(() => {
    void (async () => {
      await init();
    })();
  }, []);

  return (
    <>
      <Typography sx={styles.sideBar}>
        <Sidebar screenType={screenType.agent} />
        <Typography component="div" sx={{ flex: 1 }}>
          <Typography sx={styles.mypageHeader} component="div">
            <Typography sx={styles.mypageHeaderTitle}>
              {t('register.registInfo')}
            </Typography>
          </Typography>
          <RegisterInfo
            screen={screenType.agent}
            face={userCompany.logoId ?? noImage}
            faceUrl={userCompany.logoId ?? noImage}
            backImage={userCompany.bgImgId ?? noImage}
            companyName={userCompany.name}
            companyUrl={userCompany.url}
            statusNum={userCompany.status}
            desc={userCompany.introduction}
            table={table}
          />
        </Typography>
      </Typography>
    </>
  );
};

export default AgentRegisterInfo;
